import Highcharts from "highcharts";
import NoDataToDisplay from "highcharts/modules/no-data-to-display";  // No data to display module
import HighchartsMore from 'highcharts/highcharts-more';
import Exporting from 'highcharts/modules/exporting'
import OfflineExporting from 'highcharts/modules/offline-exporting'
import initExporting from 'highcharts/modules/exporting';
import initExportData from 'highcharts/modules/export-data';

// Load Highcharts modules
require('highcharts/modules/exporting')(Highcharts)

NoDataToDisplay(Highcharts);
HighchartsMore(Highcharts);
Exporting(Highcharts)
OfflineExporting(Highcharts)
initExporting(Highcharts);
initExportData(Highcharts);

export default Highcharts;

export const exportingOptions = {
    exporting: {
        chartOptions: {
            chart: {
                width: 2000,
                height: 1000
            },
            legend: {
                itemHiddenStyle: {
                    textDecoration: 'none',
                    color: '#ddd'
                },
            }
        }
    }
}

export const creditsOptions = {
    credits: {
        enabled: true,
        useHTML: true, // allows HTML content
        text: '<span>YetiWeb - Aineva</span>',
        href: 'https://www.aineva.it',
        position: {
            align: 'right',
            verticalAlign: 'bottom',
            x: -10,
            y: -5
        }
    }
}


export const chartLogoOptions = {
    events: {
        load: function () {
            const chart = this;
            // Render the logo in the top right corner of the chart
            chart.renderer.image(
                "/img/aineva_logo32x32.png",  // URL of the logo image
                8,  // x position
                8,  // y position
                32,  // width
                32   // height
            ).add();
        }
    }
}